import { render, staticRenderFns } from "./OServicio.vue?vue&type=template&id=4872dfc8&scoped=true&"
import script from "./OServicio.vue?vue&type=script&lang=js&"
export * from "./OServicio.vue?vue&type=script&lang=js&"
import style0 from "./OServicio.vue?vue&type=style&index=0&id=4872dfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872dfc8",
  null
  
)

export default component.exports